define ['./single_line.css'], () ->
  ($timeout) ->
    restrict: "E"
    template: require("./single_line.jade")
    scope: {field: "=", mode: "@", index: "=", stage: "="}
    link: (scope, element, attrs) ->
      poBoxRe = /^ *((#\d+)|((box|bin)[-. \/\\]?\d+)|(.*p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(number|num|#)? *\d+|(num|number|#) *\d+)/i
      firstNameRe =   /([{}"()\ \[\]])|(co-?sign)|(\bsign\b)/i
      addressWithoutStreetNumberRe = /^\s*\d+\s\w+/i
      addressOnlyStreetNumberRe = /^\d*(\.\d+)?$/g
      specialCharactersRe = /[^\w\s-.,%@#$&()/]/gi
      scope.warning = {}
      scope.warning.visible = false
      scope.validation = ""

      scope.check_content = () ->
        if scope.field.name == 'current_address__address1'
          scope.address = {}
          scope.confirm_text = 'I understand'
          # If address is PO BOX
          if poBoxRe.test(scope.field.value)
            scope.warning.text = 'It looks like you have entered a P.O. Box. In order to process reports, this should be a valid residential street address (Example: 1234 Hickory St.)'
            scope.warning.visible = true
          # If address's first character entered in field is a letter instead of a number
          else if scope.field.value and Number.isInteger(scope.field.value[0])
            scope.warning.text = 'Numbered street addresses only. If you are in a temporary address, please enter your most recent permanent address. (Example: 1234 Hickory St.)'
            scope.warning.visible = true
          # If address has a number in the field but no letters
          else if scope.field.value and addressOnlyStreetNumberRe.test(scope.field.value)
            scope.warning.text = 'Numbered street addresses only. If you are in a temporary address, please enter your most recent permanent address. (Example: 1234 Hickory St.)'
            scope.warning.visible = true
          # If address has no numbers in the field, only letters
          else if scope.field.value and not addressWithoutStreetNumberRe.test(scope.field.value)
            scope.warning.text = 'Numbered street addresses only. If you are in a temporary address, please enter your most recent permanent address. (Example: 1234 Hickory St.)'
            scope.warning.visible = true
          # If address has special characters
          else if scope.field.value and specialCharactersRe.test(scope.field.value)
            scope.warning.text = 'Note: Any special characters in your answer can potentially create issues when processing reports.'
            scope.warning.visible = true
          else
            scope.warning.visible = false

        else if scope.field.name == 'applicant__first_name'
          scope.confirm_text = 'I understand'
          if firstNameRe.test(scope.field.value)
            scope.warning.text = 'Note: This should be your first name only, exactly as it would appear on a legal document.'
            scope.warning.visible = true
          else if scope.field.value and specialCharactersRe.test(scope.field.value)
            scope.warning.text = 'Note: Any special characters in your answer can potentially create issues when processing reports.'
            scope.warning.visible = true
          else
            scope.warning.visible = false
        
        else
          scope.confirm_text = 'I understand'
          if scope.field.value and specialCharactersRe.test(scope.field.value)
            scope.warning.text = 'Note: Any special characters in your answer can potentially create issues when processing reports.'
            scope.warning.visible = true
          
        
        if scope.field.name.indexOf('zip_code') >= 0
          scope.validation = "99999"


      if scope.field.required and scope.mode == 'edit'
        scope.field_label = "#{scope.field.label}<span>&nbsp;*</span>"
      else
        scope.field_label = scope.field.label



// WEBPACK FOOTER //
// ./directives/freeforms/single_line/single_line.coffee